import {newsAdapter} from "../slices/pageNews";


export const {
    selectById: newsById,
    selectAll: selectAllNews,
} = newsAdapter.getSelectors((state)=> state.news);